export default __webpack_public_path__ + "static/media/machine-learning.de0ef0bd.png";